// @helpers
import actionTypes from "constants/actionTypes";
const { getPersonTypeAndCode } = require("utilities/hash");
const { getLanguage } = require("core/i18n").i18n;

// @actions
const signaturePatternActions = require("actions/signaturePattern");

// @utilities
const { APIGet, APIPost } = require("utilities/APIRequestHelper");
const apiURLBuilder = require("core/apiURLBuilder");

export const reset = () =>({
    type: actionTypes.AGGREGATOR_CONSENTS_WIZARD_RESET
})

export const nextStep = (currentStep) => ({
    type: actionTypes.AGGREGATOR_CONSENTS_WIZARD_NEXT_STEP,
    payload: currentStep + 1,
});

export const previousStep = (currentStep) => ({
    type: actionTypes.AGGREGATOR_CONSENTS_WIZARD_PREVIOUS_STEP,
    payload: currentStep - 1,
});

export const ownBusinessPurpousesChanged = (switchOption) => ({
    type: actionTypes.AGGREGATOR_CONSENTS_OWN_BUSINESS_SWITCH_CHANGED,
    payload: switchOption,
});

export const thirdPartiesPurpousesChanged = (switchOption) => ({
    type: actionTypes.AGGREGATOR_CONSENTS_THIRD_PARTIES_BUSINESS_SWITCH_CHANGED,
    payload: switchOption,
});

export const fetchConsentsInProgress = () => ({
    type: actionTypes.AGGREGATOR_CONSENTS_FETCH_IN_PROGRESS,
});

export const fetchConsentsSuccess = (info) => ({
    type: actionTypes.AGGREGATOR_CONSENTS_FETCH_SUCCESS,
    payload: info,
});
export const setError = () => ({
    type: actionTypes.AGGREGATOR_CONSENTS_FETCH_ERROR,
});

export const setSuccess = () => ({
    type: actionTypes.AGGREGATOR_CONSENTS_SUCCESS,
});

export const fetchChangeConsents = () => ({
    type: actionTypes.AGGREGATOR_CONSENTS_FETCH_CHANGE_CONSENTS,
});

export const fetchConsents = () => (dispatch) => {
    const requestData = {
        query: {
            placementId: "aggregator",
            status: ["ACCEPTED", "PENDING", "NOT_ACCEPTED"],
        },
    };

    dispatch(fetchConsentsInProgress());
    return APIGet(dispatch, apiURLBuilder.getURL("consents"), requestData)
        .then((res) => {
            dispatch(fetchConsentsSuccess(res));
        })
        .catch(() => dispatch(setError()));
};

export const changeConsents =
    (ownBusinessPurpouses, thirdPartiesPurpouses, dataToken) => (dispatch) => {
        const requestData = {
            newCustomer: false,
            placementId: "aggregator",
            consents: [
                { consentCellId: "01", status: ownBusinessPurpouses },
                { consentCellId: "02", status: thirdPartiesPurpouses },
            ],
            dataToken
        };
        return APIPost(dispatch, apiURLBuilder.getURL("consents"), { query: requestData })
            .then(() => dispatch(setSuccess()))
            .catch(() => dispatch(setError()));
    };

export const updateAggregatorConsents =
    (ownBusinessPurpouses, thirdPartiesPurpouses) => (dispatch, getState) => {
        const callback = (dispatch, getState, dataToken) => {
            dispatch(
                changeConsents(ownBusinessPurpouses, thirdPartiesPurpouses, dataToken)
            );
        };

        new Promise(function () {
            signaturePatternActions.validateAndExecute(
                dispatch,
                getState,
                callback
            )
        })
    };

export const getOTP = () => (dispatch) => {
    const userData = getPersonTypeAndCode();
    const idUser = userData.f;
    const documentTypeUser = userData.type;
    const requestContent = {
        clientId: idUser,
        clientType: documentTypeUser,
    };
    return APIPost({
        dispatch,
        endpoint: apiURLBuilder.getURL("signaturePatternRequestConfig", {
            id: 244,
            language: getLanguage().toLowerCase(),
        }),
        params: { requestContent },
    }).catch(() => {
        dispatch(setError());
    });
};
